import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface DocumentationAuthResponse {
  url: string
}

@Injectable({
  providedIn: 'root'
})
export class DocumentationService {
  private http = inject(HttpClient);

  getDocumentationAuthUrl(): Observable<DocumentationAuthResponse> {
    return this.http.get<DocumentationAuthResponse>(`${environment.apiUrl}/documentation/token`);
  }
}
